export const countryReducer = (state, action) => {
    const { type, payload } = action
    
    switch(type) {
        case "getDistributorsOfCity":
            return {
                ...state,
                distributors_of_city: payload.distributors_of_city,
            }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/components/pages/projects/distributors/state/reducers.js